<template>
    <div id="main">
        <!-- @71283 - Tela de listagem de Cultivar -->
        <div class="page" v-show="!rotaAninhada">
            <div class="cultivar vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t(`${abrev}-cultivar`) }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isAgro ?
                                        $t("agro") :
                                        $t("vendas")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        isAgro ?
                                        $t("agro-cadastros") :
                                        $t("crm")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t(`${abrev}-cultivar`)
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <!-- BOTÕES -->
                    <div class="header-buttons">
                        <button
                            v-if="permissao.create && !cultivarIntegracao"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${abrev}-cultivar-new` })"
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="columns is-multiline">
                    <div class="column is-three-quarters">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-campo-busca-cultivar"
                        />
                    </div>

                    <!-- SITUACAO -->
                    <div class="situacao-select column is-one-quarter">
                        <vss-select
                            ref="situacaoInput"
                            title="situacao"
                            :options="situacoes"
                            :mlLabels="true"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                            :height="40"
                            :clearable="true"
                        />
                    </div>
                </div>

                <!-- LISTAGEM -->
                <div class="cultivar-table registry-wrapper">
                    <container-loader
                        v-if="isLoading && !$store.getters.isLoading"
                    />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="allcultivares"
                        :mobile-cards="false"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            class="td-center"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'excluir'">
                                <span
                                    v-if="
                                        permissao.update && !cultivarIntegracao
                                    "
                                >
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(props.row)
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </span>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row['situacao'] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t("ativo") }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t("inativo") }}</b-tag
                                >
                            </div>
                            <div v-else-if="f.key == 'cultivar'">
                                <router-link
                                    :to="{
                                        name: `${abrev}-cultivar-edit`,
                                        params: { id: props.row.id, descricao: props.row[f.key] },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else>
                                <router-link
                                    :to="{
                                        name: `${abrev}-cultivar-edit`,
                                        params: { id: props.row.id, descricao: props.row['cultivar'] },
                                    }"
                                >
                                    {{ props.row[f.key] }}
                                </router-link>
                            </div>
                        </b-table-column>
                    </b-table>
                </div>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import CultivarService from "@/services/agro/CultivarService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("cultivar") && !to.name.includes("cultivar-list")) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            cultivarIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("CULTIVAR"),
            allcultivares: [],
            service: new CultivarService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: '10%', sortable: true, sortFn: null },
                { key: "cultivar", width: null, sortable: true, sortFn: null },
                { key: "cultura", width: null, sortable: true, sortFn: null },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            situacoes: [
                { label: "todos", id: 2 },
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            situacao: { label: "todos", id: 2 },
            sort: {
                order: "desc",
                column: "cultivar",
            },
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        if (this.$route.name.includes("cultivar") && !this.$route.name.includes("cultivar-list")) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        // Seleciona o valor na posição do array de opções de paginação
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-cultivar"
            );
        }else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "crm",
                "ven-cultivar"
            );
        }

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: `${this.abrev}-cultivar` },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados(1);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service.findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allcultivares = value;
                    this.isEmpty = this.allcultivares.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar!");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body && body.content) {
                this.pagination.totalRows = body.totalElements;
                let cultivarlist = body.content.map((mf) => {
                    return {
                        id: mf.idcultivar,
                        codigo: mf.idcultivarerp,
                        cultivar: mf.descricao,
                        cultura: mf.tipocultura,
                        idtipocultura: mf.idtipocultura,
                        situacao: mf.situacao,
                    };
                });
                return cultivarlist;
            } else {
                return [];
            }
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row["cultivar"] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacaoRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            this.isLoading = true;

            let cultivarTemp = {
                idcultivar: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.service.updateSituacao(cultivarTemp, this.abrev)
                .then((r) => {
                    if (r.status == 200) {
                        if (r.content.situacao == 1) {
                            this.$root.showMessage(
                                "success",
                                "msg-reativou-cultura"
                            );
                        } else if (r.content.situacao == 0) {
                            this.$root.showMessage(
                                "success",
                                "msg-inativou-cultura"
                            );
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "msg-problema-realizar-acao"
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status do vincular.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao"
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
}

.page {
    position: relative;
    padding-left: 0;

    .title-breadcrumb {
        padding-bottom: 10px;
    }
    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}
</style>